
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { getEnum } from "@/service/supplier-meta/api";
import { enumToOption } from "@/utils";
import { supplierTypeEnum } from "@/service/supplier-meta/enums/supplierTypeEnum";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { Form } from "element-ui";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { getSupplierServices } from "@/service/supplier-meta/common/supplier-info-service";
import { purchaseTypeEnum } from "@/service/supplier-meta/enums/purchaseTypeEnum";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class baseInfo extends SupplierForm {
  form = {
    scaleType: null as number | null,
    supplierType: null as number | null,
    enterpriseInfo: {
      operatorContact: "",
      operatingTime: "",
      employeeQuantity: null as number | null,
      domicileOrLocationCode: "",
      economicTypeCode: "",
      industryAttributeCode: "",
      complianceType: null as number | null,
      purchaseType: [purchaseTypeEnum.销售采购], //自主入驻默认销售采购
      webUrl: "",
      supplyRegion: null as number | null,
    },
    serverItems: [] as number[],
  };
  scaleTypeOptions: SelectOption[] = [];
  supplierTypeOptions: SelectOption[] = [];
  purchaseTypeOptions: SelectOption[] = [];
  complianceTypeOptions: SelectOption[] = [];
  supplierServiceOptions: SelectOption[] = [];
  supplyRegionOptions: SelectOption[] = [];
  get rules(): ElementUIFormRules {
    return {
      ...this.getFieldsRules([
        "scaleType",
        "supplierType",
        "enterpriseInfo.operatorContact",
        "enterpriseInfo.operatingTime",
        "enterpriseInfo.employeeQuantity",
        "enterpriseInfo.economicTypeCode",
        "enterpriseInfo.industryAttributeCode",
        "enterpriseInfo.complianceType",
        "enterpriseInfo.domicileOrLocationCode",
        "enterpriseInfo.purchaseType",
        "enterpriseInfo.supplyRegion",
        "serverItems",
        "enterpriseInfo.webUrl",
      ]),
    };
  }
  get matchedSupplierServicesOptions(): SelectOption[] {
    const supplierServiceKeys = getSupplierServices(
      this.isClothingCategory,
      this.submitData.factoryInfo?.supplyClassification,
      this.submitData.enterpriseInfo?.supplyType
    );
    const opts: SelectOption[] = [];
    supplierServiceKeys.forEach((key) => {
      const matchedOpt = this.supplierServiceOptions.find(
        (opt) => opt.value === key
      );
      if (matchedOpt) {
        opts.push(matchedOpt);
      }
    });
    return opts;
  }
  get matchedSupplierTypeOptions(): SelectOption[] {
    switch (this.sourceType) {
      case sourceTypeEnum.oa:
        return this.supplierTypeOptions;
      case sourceTypeEnum.pmc_supplier:
        return this.supplierTypeOptions.filter((opt) =>
          [
            supplierTypeEnum.贸易,
            supplierTypeEnum.品牌,
            supplierTypeEnum.工厂,
          ].includes(opt.value as number)
        );
      case sourceTypeEnum.pmc_factory:
        return this.supplierTypeOptions.filter((opt) =>
          [supplierTypeEnum.工厂].includes(opt.value as number)
        );
    }
    return [];
  }
  created() {
    this.getOptions();
  }
  getOptions() {
    getEnum("ScaleTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.scaleTypeOptions = enumToOption(res.result);
      }
    });
    getEnum("SupplierTypeEnum", true).then((res) =>
      res.isSuccess ? (this.supplierTypeOptions = enumToOption(res.result)) : []
    );
    getEnum("PurchaseTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.purchaseTypeOptions = enumToOption(res.result);
      }
    });
    getEnum("SupplierComplianceTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.complianceTypeOptions = enumToOption(res.result);
      }
    });
    getEnum("SupplierServerEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.supplierServiceOptions = enumToOption(res.result);
      }
    });
    getEnum("SupplyRegionEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.supplyRegionOptions = enumToOption(res.result);
      }
    });
  }
  getFormRef(): Form {
    return this.$refs.form as Form;
  }
  getFormData() {
    const services = this.form.serverItems.filter((svc) =>
      this.matchedSupplierServicesOptions.some((opt) => opt.value === svc)
    );
    return {
      ...this.form,
      serverItems: services,
    };
  }
}
